import { VisualDataPanel } from "@/components/triarch/VisualDataPanel";
import { FinalCTA } from "@/components/triarch/FinalCTA";

export default function ArchivePage() {
  return (
    <div className="pt-24 sm:pt-28">
      <VisualDataPanel />
      <FinalCTA />
    </div>
  );
}
